import React, { useMemo, useState } from 'react';
import { useAppSelector } from '../../store';
import { useTranslation } from 'react-i18next';
import ShowContainer from '../material-ui/ShowContainer';
import CusLabelSelect from '../material-ui/CusLabelSelect';

export default function FreeSpinSelect({
  id,
  value,
  setValue,
  groupId,
  fullWidth,
  label = 'Freespin template',
  currency = null,
  plugNoCampaign = null
}) {
  const { t } = useTranslation();
  const campaignsGroup = useAppSelector((state) => state.freeSpin.campaignByGroupId?.[groupId]);
  const [hasCampaign, setHasCampaign] = useState(campaignsGroup);

  const fsOptions = useMemo(() => {
    try {
      let campaigns = campaignsGroup;
      if (!campaignsGroup) return undefined;
      if (currency) campaigns = campaignsGroup.filter((el) => el.currency === currency);

      const fsOptions = campaigns?.map((el) => ({ label: el.name, value: el.campaignId }));
      setHasCampaign(fsOptions.length);

      fsOptions.unshift({ label: 'Select', value: '' });
      return fsOptions;
    } catch (e) {
      return undefined;
    }
  }, [campaignsGroup, currency]);

  return (
    <ShowContainer condition={hasCampaign} plug={plugNoCampaign || t('no campaigns')}>
      <CusLabelSelect
        fullWidth={fullWidth}
        id={id}
        label={label}
        options={fsOptions}
        value={value}
        onChange={setValue}
      />
    </ShowContainer>
  );
}
